<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-backdrop
    @hidden="resetForm"
    @change="(val) => toggleSidebar(val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ titleForm }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="tipoPersona"
            rules="required"
          >
            <b-form-group
              label="Tipo Persona"
              label-for="tipoPersona"
            >
              <b-form-select
                v-model="tipoPersona"
                type="select"
                class="custom-select"
              >
                <option value="">
                  SELECCIONE::
                </option>
                <option value="NATURAL">
                  NATURAL
                </option>
                <option value="JURIDICA">
                  JURÍDICA
                </option>
              </b-form-select>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="tipoDocumento"
            rules="required"
          >
            <b-form-group
              label="Tipo Documento"
              label-for="tipoDocumento"
            >
              <b-form-select
                v-model="tipoDocumento"
                type="select"
                class="custom-select"
              >
                <option value="">
                  SELECCIONE::
                </option>
                <option value="DNI">
                  DNI
                </option>
                <option value="RUC">
                  RUC
                </option>
                <option value="CARNET_EXT">
                  CARNET EXT
                </option>
                <option value="PASAPORTE">
                  PASAPORTE
                </option>
              </b-form-select>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Documento"
            rules="required"
          >
            <b-form-group
              label="Documento"
              label-for="documento"
            >
              <b-input-group>
                <b-form-input
                  id="documento"
                  v-model="formData.documento"
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder=""
                />
                <b-input-group-append
                  @click="validarDocumento()"
                >
                  <b-button
                    variant="outline-primary"
                  >
                    <feather-icon
                      icon="SearchIcon"
                      size="14"
                      class="align-middle text-body"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <div
            v-if="isBusyReniec"
            class="text-center text-primary my-2"
          >
            <b-spinner
              variant="primary"
              class="align-middle"
            />
            <strong class="ml-1">Cargando...</strong>
          </div>
          <validation-provider
            #default="validationContext"
            name="Nombre"
            rules="required"
          >
            <b-form-group
              label="Nombres"
              label-for="nombre"
            >
              <b-form-input
                id="nombre"
                v-model="formData.nombre"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="ApellidoPaterno"
            rules="required"
          >
            <b-form-group
              label="Apellido Paterno"
              label-for="ApellidoPaterno"
            >
              <b-form-input
                id="ApellidoPaterno"
                v-model="formData.apellidoPaterno"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="ApellidoMaterno"
            rules="required"
          >
            <b-form-group
              label="Apellido Materno"
              label-for="ApellidoMaterno"
            >
              <b-form-input
                id="ApellidoMaterno"
                v-model="formData.apellidoMaterno"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Sexo"
            rules="required"
          >
            <b-form-group
              label="Sexo"
              label-for="sexo"
            >
              <div class="demo-inline-spacing">
                <b-form-radio
                  v-model="formData.sexo"
                  plain
                  name="some-radios3"
                  value="M"
                >
                  M
                </b-form-radio>
                <b-form-radio
                  v-model="formData.sexo"
                  plain
                  name="some-radios3"
                  value="F"
                >
                  F
                </b-form-radio>
              </div>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="EstadoCivil"
            rules="required"
          >
            <b-form-group
              label="Estado Civil"
              label-for="estadoCivil"
            >
              <b-form-select
                v-model="estadoCivil"
                type="select"
                class="custom-select"
              >
                <option value="">
                  SELECCIONE::
                </option>
                <option value="SOLTERO">
                  SOLTERO
                </option>
                <option value="CASADO">
                  CASADO
                </option>
                <option value="VIUDO">
                  VIUDO
                </option>
                <option value="DIVORCIADO">
                  DIVORCIADO
                </option>
              </b-form-select>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-form-group
            label="Dirección"
            label-for="direccion"
          >
            <b-form-input
              id="direccion"
              v-model="formData.direccion"
              trim
            />
          </b-form-group>
          <validation-provider
            #default="validationContext"
            name="Telefono"
            rules="required"
          >
            <b-form-group
              label="Teléfono"
              label-for="telefono"
            >
              <b-form-input
                id="telefono"
                v-model="formData.telefono"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-form-group
            label="Email"
            label-for="email"
          >
            <b-form-input
              id="email"
              v-model="formData.email"
              trim
            />
          </b-form-group>
          <b-form-group
            v-show="false"
            label="Representante Legal"
            label-for="RepresentanteLegal"
          >
            <b-form-input
              id="RepresentanteLegal"
              v-model="formData.representanteLegal"
              trim
            />
          </b-form-group>
          <b-form-group
            label="Departamento"
            label-for="departamento"
          >
            <v-select
              v-model="departamento"
              placeholder=".: Seleccione Departamento :."
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="optionDepartamento"
              :reduce="m => m.codigoDepartamento"
              label="descripcion"
              :clearable="false"
              input-id="descripcion"
              @input="getSelectedDepartamento"
            />
          </b-form-group>
          <b-form-group
            label="Provincia"
            label-for="provincia"
          >
            <v-select
              v-model="formData.provincia"
              placeholder=".: Seleccione Provincia :."
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="optionProvincia"
              :reduce="m => m.codigoProvincia"
              label="descripcion"
              :clearable="false"
              input-id="descripcion"
              @input="getSelectedProvincia"
            />
          </b-form-group>
          <b-form-group
            label="Distrito"
            label-for="distrito"
          >
            <v-select
              v-model="formData.distrito"
              placeholder=".: Seleccione Distrito :."
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="optionDistrito"
              :reduce="m => m.codigoDistrito"
              label="descripcion"
              :clearable="false"
              input-id="descripcion"
              @input="getSelectedDistrito"
            />
          </b-form-group>
          <b-form-group
            label="Centro Poblado"
            label-for="centroPoblado"
          >
            <v-select
              v-model="formData.centroPoblado"
              placeholder=".: Seleccione Distrito :."
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="optionCentroPoblado"
              :reduce="m => m.codigoCentroPoblado"
              label="descripcion"
              :clearable="false"
              input-id="descripcion"
            />
          </b-form-group>
          <!-- Detail -->
          <div class="row">
            <div class="col-md-12">
              <div
                class="mt-2"
                style="text-align:end"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-success"
                  class="mr-2"
                  @click="addUbigeo"
                >
                  Agregar Ubigeo
                </b-button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span>Lista de ubigeos</span>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-12">
              <b-table
                :items="itemsUbigeo"
                :fields="fields"
                striped
                responsive
                :busy="isBusyUbigeo"
              >
                <template #cell(ubigeo)="data">
                  <b-media vertical-align="center">
                    <b-link
                      class="font-weight-bold d-block text-nowrap"
                    >
                      {{ data.item.ubigeo }}
                    </b-link>
                    <small class="text-muted">{{ data.item.descripcion }}</small>
                  </b-media>
                </template>
                <template #cell(op)="row">
                  <a
                    href="javascript:void(0)"
                    title="Eliminar"
                    @click.stop="deleteRow(row, 'delete')"
                  >
                    <feather-icon
                      icon="Trash2Icon"
                      class="mr-50 fa-red"
                    />
                  </a>
                </template>
              </b-table>
            </div>
          </div>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="isBusy"
            >
              Guardar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import Vue from 'vue'
import {
  BSidebar, BForm, BFormGroup, BSpinner, BTable, BFormInput, BFormInvalidFeedback, BButton, BFormRadio, BFormSelect, BInputGroup, BInputGroupAppend, BLink, BMedia,
} from 'bootstrap-vue'
import { _ } from 'vue-underscore'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import { useNotify } from '@/helpers/toast'

export default {
  components: {
    BSidebar,
    BSpinner,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BFormRadio,
    BFormSelect,
    vSelect,
    BInputGroup,
    BInputGroupAppend,
    BTable,
    BLink,
    BMedia,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    dataEdit: {
      type: Object,
      required: false,
      default: null,
    },
    dataReniec: {
      type: Object,
      required: false,
      default: null,
    },
    formType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  setup(props, context) {
    const { notify } = useNotify(context)
    const isBusyReniec = ref(false)
    const itemsUbigeo = ref([])
    const isBusyUbigeo = ref(false)
    const departamento = ref('')
    const optionTecnico = ref([])
    const tecnico = ref('')
    const fields = ref([
      { key: 'ubigeo' },
      { key: 'op', thStyle: { width: '5px' } },
    ])
    const blankData = {
      documento: '',
      nombre: '',
      apellidoPaterno: '',
      apellidoMaterno: '',
      sexo: 'F',
      direccion: '',
      telefono: '',
      email: '',
      representanteLegal: '',
      idUbigeo: '',
      observacion: '',
      foto: '',
    }
    const estadoCivil = ref('')
    const tipoDocumento = ref('')
    const institucion = ref('')
    const tipoPersona = ref('')
    const titleForm = ref('')
    const optionDepartamento = ref([])
    const optionDistrito = ref([])
    const optionCentroPoblado = ref([])
    const optionProvincia = ref([])
    const isBusy = ref(false)
    const arrDetail = ref([])
    const bval = ref(true)

    const formData = ref(JSON.parse(JSON.stringify(blankData)))/* desestructuracion de  blankData */
    const resetData = () => {
      formData.value = JSON.parse(JSON.stringify(blankData))
    }
    const addUbigeo = () => {
      if (!_.isUndefined(formData.value.distrito) && formData.value.distrito !== '' && formData.value.centroPoblado !== '') {
        const filteredUbdp = _.findWhere(optionDepartamento.value, { codigoDepartamento: departamento.value })
        const filteredUbp = _.findWhere(optionProvincia.value, { codigoProvincia: formData.value.provincia })
        const filteredUbds = _.findWhere(optionDistrito.value, { codigoDistrito: formData.value.distrito })
        const filteredUbdsCpp = _.findWhere(optionCentroPoblado.value, { codigoCentroPoblado: formData.value.centroPoblado })
        const row = {
          index: 0,
          ubigeo: `${departamento.value}${formData.value.provincia}${formData.value.distrito}${formData.value.centroPoblado}`,
          descripcion: `${filteredUbdp.descripcion} - ${filteredUbp.descripcion} - ${filteredUbds.descripcion} - ${filteredUbdsCpp.descripcion}`,
        }
        if (!_.contains(arrDetail.value, row.ubigeo)) {
          itemsUbigeo.value.push(row)
          itemsUbigeo.value.forEach((da, i) => {
            itemsUbigeo.value[i].index = i
          })
          arrDetail.value.push(row.ubigeo)
        } else {
          notify('Advertencia', 'Este ubigeo ya fue agregado', 'warning')
        }
      } else {
        notify('Advertencia', 'Seleccione ubigeo', 'warning')
      }
    }
    const deleteRow = row => {
      Vue.swal({
        title: 'Está seguro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          itemsUbigeo.value.splice(row.index, 1)
          arrDetail.value = _.reject(arrDetail.value, item => item === row.item.ubigeo)
        }
        // console.log(arrDetail.value)
      })
    }
    const onSubmit = () => {
      isBusy.value = true
      bval.value = true
      formData.value.tipoPersona = tipoPersona.value
      formData.value.tipoDocumento = tipoDocumento.value
      formData.value.estadoCivil = estadoCivil.value
      /* concatenando ubigeos */
      if (itemsUbigeo.value.length <= 0) {
        notify('Advertencia', 'Es necesario agregar un ubigeo', 'warning')
        bval.value = false
        isBusy.value = false
      }
      let ub = ''
      itemsUbigeo.value.forEach(dat => {
        ub += `${dat.ubigeo},`
      })
      if (bval.value) {
        formData.value.idUbigeo = ub.slice(0, -1)
        /* concatenando ubigeos */
        let service = 'gsencuesta/ENCUESTADO_CREATE'
        if (props.formType === 'edit') {
          service = 'gsencuesta/ENCUESTADO_UPDATE'
        }
        store.dispatch(service, formData.value)
          .then(response => {
            isBusy.value = false
            context.emit('refetch-data', response)
            context.emit('update:is-add-new-user-sidebar-active', false)
          })
          .catch(error => {
            isBusy.value = false
            // notify('Ha ocurrido un error', error.response.data.message, 'danger')
            notify('Ha ocurrido un error', error.response.data.errorMessage, 'danger')
            // context.emit('error-data', error)
            // context.emit('update:is-add-new-user-sidebar-active', false)
          })
      }
    }
    const loadProvincia = async codigoDepartamento => {
      const provinciaDefault = {
        id: '',
        descripcion: '',
      }
      await store
        .dispatch('gsencuesta/UBIGE_FIND_ALL_PROVINCIA', {
          id: codigoDepartamento,
        })
        .then(response => {
          optionProvincia.value = []
          if (response !== undefined) {
            optionProvincia.value = response
          }
          optionProvincia.value.unshift(provinciaDefault)
        })
        .catch(error => {
          this.$bvToast.tost(error, {
            title: 'Ha ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    }
    const dataForm = async () => {
      const provinciaDefault = {
        id: '',
        descripcion: '',
      }
      optionProvincia.value.unshift(provinciaDefault)
      const distritoDefault = {
        id: '',
        descripcion: '',
      }
      optionDistrito.value.unshift(distritoDefault)
      const deparmentDefault = {
        id: '',
        descripcion: '',
      }
      const centroPobladoDefault = {
        id: '',
        descripcion: '',
      }
      optionCentroPoblado.value.push(centroPobladoDefault)
      await store
        .dispatch('gsencuesta/UBIGEO_FIND_ALL_DEPARTAMENTO', {})
        .then(response => {
          if (response !== undefined) {
            optionDepartamento.value = response
            optionDepartamento.value.unshift(deparmentDefault)
            departamento.value = '22'
            loadProvincia(departamento.value)
          }
        })
        .catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
      await store
        .dispatch('gsencuesta/USUARIO_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: '',
          idPerfil: 4, // TECNICO
        })
        .then(response => {
          if (response !== undefined) {
            /* response.forEach((dat, index) => {
              optionTecnico.value.push({
                index,
                idUsuario: dat.idUsuario,
                nombre: `${dat.nombre} ${dat.apellidoPaterno} ${dat.apellidoMaterno}`,
              })
            }) */
            optionTecnico.value = response
          }
        })
        .catch(error => {
          notify(error, 'He ocurrido un error', 'danger')
        })
    }
    const loadDistrito = async codigoProvincia => {
      const distritoDefault = {
        id: '',
        descripcion: '',
      }
      await store
        .dispatch('gsencuesta/UBIGE_FIND_ALL_DISTRITO', {
          codigoDepartamento: departamento.value,
          codigoProvincia,
        })
        .then(response => {
          optionDistrito.value = []
          if (response !== undefined) {
            optionDistrito.value = response
          }
          optionDistrito.value.unshift(distritoDefault)
        })
        .catch(error => {
          this.$bvToast.toast(error, {
            title: 'Ha ocdssd',
            variant: 'danger',
            solid: true,
          })
        })
    }
    const loadCentroPoblado = async codigoDistrito => {
      const centroPobladoDefault = {
        id: '',
        descripcion: '',
      }
      await store
        .dispatch('gsencuesta/UBIGE_FIND_ALL_CENTRO_POBLADO', {
          codigoDepartamento: departamento.value,
          codigoProvincia: formData.value.provincia,
          codigoDistrito,
        })
        .then(response => {
          optionCentroPoblado.value = []
          if (response !== undefined) {
            optionCentroPoblado.value = response
          }
          optionCentroPoblado.value.unshift(centroPobladoDefault)
        })
        .catch(error => {
          this.$bvToast.toast(error, {
            title: 'Ha ocdssd',
            variant: 'danger',
            solid: true,
          })
        })
    }
    const getSelectedDepartamento = option => {
      loadProvincia(option)
    }
    const getSelectedProvincia = option => {
      loadDistrito(option)
    }
    const getSelectedDistrito = option => {
      loadCentroPoblado(option)
    }
    /* const getSelectedDistrito = option => {
      console.log(option)
      // formData.value.idUbigeo = formData.value.departamento + formData.value.provincia + option
    } */
    const validarDocumento = () => {
      if (formData.value.documento !== '') {
        isBusyReniec.value = true
        store
          .dispatch('gsencuesta/ENCUESTADO_FIND_ALL_RENIEC', {
            dni: formData.value.documento,
          })
          .then(res => {
            const dataReniec = res.datosPersona === undefined ? [] : res.datosPersona
            formData.value.nombre = dataReniec.prenombres
            formData.value.apellidoPaterno = dataReniec.apPrimer
            formData.value.apellidoMaterno = dataReniec.apSegundo
            formData.value.foto = dataReniec.foto
            isBusyReniec.value = false
          })
          .catch(error => {
            notify('Advertencia', error.response.data.errorMessage, 'warning')
            isBusyReniec.value = false
          })
      }
    }
    const toggleSidebar = async val => {
      arrDetail.value = []
      itemsUbigeo.value = []
      const distefault = {
        id: '',
        descripcion: '',
      }
      optionProvincia.value = []
      optionProvincia.value.unshift(distefault)
      optionDistrito.value = []
      optionDistrito.value.unshift(distefault)
      await dataForm()
      context.emit('update:is-add-new-user-sidebar-active', val)
      institucion.value = ''
      if (props.formType === 'new') {
        titleForm.value = 'Nuevo Encuestado'
      }
      if (props.formType === 'edit') {
        if (props.dataEdit.ubigeoAllList !== null && props.dataEdit.ubigeoAllList.length > 0) {
          props.dataEdit.ubigeoAllList.forEach((dat1, index) => {
            const row = {
              index,
              ubigeo: dat1.ubigeo_id,
              descripcion: `${dat1.dpto} - ${dat1.prov} - ${dat1.dist} - ${dat1.cp}`,
            }
            itemsUbigeo.value.push(row)
            arrDetail.value.push(row.ubigeo)
          })
        }
        formData.value = {
          idEncuestado: props.dataEdit.idEncuestado,
          nombre: props.dataEdit.nombre,
          foto: props.dataEdit.foto,
          apellidoPaterno: props.dataEdit.apellidoPaterno,
          apellidoMaterno: props.dataEdit.apellidoMaterno,
          sexo: props.dataEdit.sexo,
          direccion: props.dataEdit.direccion,
          telefono: props.dataEdit.telefono,
          email: props.dataEdit.email,
          documento: props.dataEdit.documento,
          representanteLegal: props.dataEdit.representanteLegal,
          observacion: props.dataEdit.observacion,
          // meta: props.dataEdit.meta,
        }
        tipoPersona.value = props.dataEdit.tipoPersona
        tipoDocumento.value = props.dataEdit.tipoDocumento
        estadoCivil.value = props.dataEdit.estadoCivil
        titleForm.value = 'Editar Encuestado'
      }
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)
    return {
      formData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      estadoCivil,
      tipoDocumento,
      tipoPersona,
      toggleSidebar,
      optionProvincia,
      optionDepartamento,
      optionDistrito,
      titleForm,
      getSelectedDepartamento,
      getSelectedProvincia,
      // getSelectedDistrito,
      validarDocumento,
      isBusyReniec,
      isBusy,
      itemsUbigeo,
      isBusyUbigeo,
      fields,
      deleteRow,
      addUbigeo,
      arrDetail,
      departamento,
      optionTecnico,
      tecnico,
      loadCentroPoblado,
      getSelectedDistrito,
      optionCentroPoblado,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
